angular
  .module('ManagerControllers')

  .controller('ManagerHomeCtrl', [
    '$scope',
    'api',
    function($scope, api) {
      api.getInstitutionSummary().then(function(data) {
        console.log('data', data);
        $scope.credits = data.parent_institution_id
          ? data.parent_institution.credits
          : data.credits;

        $scope.translationsDatas = {
          credits: $scope.credits
        };

        $scope.students = data.profiles.filter(function(profile) {
          return profile.is_teacher === false;
        });

        $scope.teachers = data.profiles.filter(function(profile) {
          return profile.is_teacher === true;
        });
      });
    }
  ]);
